<script>
import CommonRules from "@/mixins/CommonRules";
import UserAuth from "@/mixins/UserAuth";
import VTextFieldPassword from "@/components/commonComponents/VTextFieldPassword.vue";

export default {
    name: "Auth",
    components: {
        VTextFieldPassword,
    },
    mixins: [
        CommonRules,
        UserAuth,
    ],
    data() {
        return {
            isVisiblePassword: false,
            isValid: false,
            isLoading: true,
            form: {
                username: '',
                password: '',
            },
            poolIntervalId: null,
            interceptorId: null,
            notifyOptions: {
                title: 'Авторизация',
            },
        };
    },
    computed: {
        isCanSubmit() {
            return this.isValid && !this.isLoading;
        }
    },
    mounted() {
        this.pool();
        this.poolIntervalId = setInterval(this.pool, 60 * 1000);
        this.interceptorId = this.$api.getClient().interceptors.response.use(
            response => response,
            error => {
                if (error.status === 401) {
                    this.isAuthorized = false;
                    this.user = {};
                }
                return Promise.reject(error);
            });
    },
    beforeDestroy() {
        if (this.poolIntervalId) {
            clearInterval(this.poolIntervalId);
        }
        if (this.interceptorId !== null) {
            this.$api.getClient().interceptors.response.eject(this.interceptorId);
        }
    },
    methods: {
        pool() {
            this.$api.get(this.$apiUrl.getUserProfileUrl())
                .then(response => response?.data?.data)
                .then((response) => {
                    this.isAuthorized = true;
                    this.user = response;
                })
                .catch(() => {
                    this.isAuthorized = false;
                    this.user = {};
                })
                .finally(() => {
                    this.isLoading = false;
                })
        },
        onClickAuth() {
            this.isLoading = true;
            this.$api.post(this.$apiUrl.getUserAuthUrl(), this.form)
                .then(response => response.data?.data)
                .then((response) => {
                    // if (!response) {
                    //     throw "Неверный логин и/или пароль";
                    // }
                    this.$refs.form?.reset();
                    this.isAuthorized = true;
                    this.user = response;
                })
                .catch((e) => {
                    this.isAuthorized = false;
                    this.user = {};
                    this.notifyError(e);
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
    },
}
</script>

<template>
    <v-container fill-height v-if="!isAuthorized">
        <v-card class="mx-auto" width="448" max-width="448" justify="center" :loading="isLoading">
            <v-card-title>Авторизация</v-card-title>
            <v-form v-model="isValid" @submit.prevent="onClickAuth" ref="form">
                <v-card-text>
                    <v-container fluid>
                        <v-row>
                            <v-col class="pa-0">
                                <v-text-field
                                    v-model="form.username"
                                    :rules="[rules.required]"
                                    :disabled="isLoading"
                                    autocomplete="off"
                                    label="E-mail"
                                    prepend-inner-icon="mdi-email-outline"
                                    type="email"
                                    class="required"
                                    clearable
                                ></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col class="pa-0">
                                <v-text-field-password
                                    v-model="form.password"
                                    :rules="[rules.required]"
                                    :disabled="isLoading"
                                    prepend-inner-icon="mdi-lock-outline"
                                    class="required"
                                    clearable
                                ></v-text-field-password>
                            </v-col>
                        </v-row>

                    </v-container>

                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        :disabled="!isCanSubmit"
                        color="primary"
                        type="submit"
                    >
                        Авторизация
                    </v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-container>
</template>

<style scoped lang="scss">

</style>
